import React, { useCallback } from 'react';
import { LockOutlined } from '@ant-design/icons';
import { Button, Form, Input, Typography, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from './ForgotPasswordServices';
import { useGlobal } from '../Shared/GlobalContext/GlobalContext';
import CommonWrapper from '../Shared/CommonWrapper/CommonWrapper';

const { Text } = Typography;

const ForgotPassword = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { loading, setLoading } = useGlobal();

    const onFinish = useCallback(async (values) => {
        try {
            setLoading(true);
            await forgotPassword(values.email);
            message.success(t('password_reset_instructions_sent'));
            navigate('/login');
        } catch (error) {
            const errorMessage = error.response?.data?.message || t('error_processing_request');
            message.error(errorMessage);
        } finally {
            setLoading(false);
        }
    }, [navigate, setLoading]);

    const handleLoginRedirect = () => {
        navigate('/login');
    };

    return (
        <CommonWrapper>
            <Form
                name="forgot-password"
                style={{ maxWidth: '100%', margin: '0 auto' }}
                onFinish={onFinish}
            >
                <Form.Item
                    name="email"
                    rules={[
                        { required: true, message: t('please_input_your_email') },
                        { type: 'email', message: t('please_enter_a_valid_email') }
                    ]}
                >
                    <Input
                        prefix={<LockOutlined />}
                        placeholder={t('email')}
                        size="large"
                        style={{ borderRadius: '5px' }}
                    />
                </Form.Item>
                <Form.Item>
                    <Button
                        block
                        type="primary"
                        htmlType="submit"
                        size="large"
                        loading={loading}
                    >
                        {t('reset_password')}
                    </Button>
                </Form.Item>
                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                    <Text>{t('remember_your_password')} </Text>
                    <Button
                        type="link"
                        style={{ fontSize: '0.9em', padding: 0 }}
                        onClick={handleLoginRedirect}
                    >
                        {t('go_back_to_login')}
                    </Button>
                </div>
            </Form>
        </CommonWrapper>
    );
};

export default ForgotPassword;
